<template>
    <div class="select-range" :class="{active: changed}" :changed="changed" :reset="options.defaultValue !== null"  :label="label">
        <button v-if="options.defaultValue !== null" class="select-close" @click="reset">
            <i class="icon-times"></i>
        </button>
        <div>
            <select class="min" ref="minList" v-model="minValue" :changed="minChanged" >
                <option v-for="item in minList" :value="item.value">
                    {{ item.text }}
                </option>
            </select>
            <div class="split">-</div>
            <select  class="max" ref="maxList" v-model="maxValue" :changed="maxChanged">
                <option v-for="(item,index) in maxList" :value="item.value">
                    {{ item.text }}
                </option>
            </select>
            <label v-text="selectedItemText"></label>
        </div>
    </div>
</template>

<script src="./mvt-selectrange.js"></script>

<style lang="scss">
@use './mvt-selectrange.scss' as *;
</style>
